// Costo acquisto automatico dallo SKU: MC01_ = 70% del prezzo base; MC02_/MC03_ = 0,5 per DVD e 1 per BLU RAY. null = nessuna regola.
export const calcolaCostoAcquisto = ({ sku, supporto, prezzo_negozio_base, prezzo_negozio }) => {
  const s = (sku || '').toUpperCase();
  if (s.startsWith('MC01_')) {
    const base = parseFloat(prezzo_negozio_base) || parseFloat(prezzo_negozio);
    return base > 0 ? Math.round(base * 0.7 * 100) / 100 : null;
  }
  if (s.startsWith('MC02_') || s.startsWith('MC03_')) {
    if (supporto === 'DVD') return 0.5;
    if (supporto === 'BLU RAY') return 1;
  }
  return null;
};
